import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Progress } from './ui/progress';
import { useAuth } from '@/contexts/AuthContext';

const TrialProgress = () => {
  const { user } = useAuth();
  const [requestsUsed, setRequestsUsed] = useState(0);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!user) return;

      const { data, error } = await supabase
        .from('profiles')
        .select('trial_requests_used, is_subscribed')
        .eq('id', user.id)
        .single();

      if (!error && data) {
        setRequestsUsed(data.trial_requests_used);
        setIsSubscribed(data.is_subscribed);
      }
      setLoading(false);
    };

    fetchProfile();

    // Set up real-time subscription to profile changes
    const channel = supabase
      .channel('profile-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'profiles',
          filter: `id=eq.${user?.id}`,
        },
        (payload) => {
          const newData = payload.new as any;
          setRequestsUsed(newData.trial_requests_used);
          setIsSubscribed(newData.is_subscribed);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user]);

  if (loading || isSubscribed) return null;

  const remainingRequests = Math.max(0, 10 - requestsUsed);
  const progressPercent = (requestsUsed / 10) * 100;

  return (
    <div className="bg-card border rounded-lg p-4 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium">Trial Progress</span>
        <span className="text-sm text-muted-foreground">
          {remainingRequests} requests left
        </span>
      </div>
      <Progress value={progressPercent} className="h-2" />
      {remainingRequests === 0 && (
        <p className="text-xs text-destructive mt-2">
          Trial limit reached. Please subscribe to continue.
        </p>
      )}
    </div>
  );
};

export default TrialProgress;
